import {
    GET_OVERRIDE_REASONS,
    GET_OVERRIDE_REASONS_SUCCESS,
    GET_OVERRIDE_REASONS_FAILURE,
} from '../actions';

const initialState = {
    loading: false,
    overrideReasons: [],
    statusCode: '',
    statusMessage: '',
};

const overrideReasonsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_OVERRIDE_REASONS:
            return {
                ...state,
                loading: true,
            };
        case GET_OVERRIDE_REASONS_SUCCESS:
            return {
                ...state,
                loading: false,
                overrideReasons: action.data.overrideReasons || [],
                statusCode: action.data.statusCode || '',
                statusMessage: action.data.statusMessage || '',
            };
        case GET_OVERRIDE_REASONS_FAILURE:
            return {
                ...state,
                loading: false,
                overrideReasons: [],
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        default:
            return state;
    }
};

export default overrideReasonsReducer;
